import axios from 'axios';

export const sendSlackMessage = async (text, channel, bot = undefined) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_COMMUNICATION_API}/slack`,
      {
        text,
        channel,
        bot,
      }
    );
    return response?.data;
  } catch (error) {
    console.log(error);
  }
};
